import React from "react";
import ChatApp from "./chartApp";

const App: React.FC = () => {
  return (
    <div className="App">
      <ChatApp />
    </div>
  );
};

export default App;
